// Minimal IANA time-zone math via Intl (no dependency).

// Offset (ms) of `tz` from UTC at instant `ms`.
function tzOffset(ms, tz) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  }).formatToParts(new Date(ms));
  const v = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  return Date.UTC(+v.year, +v.month - 1, +v.day, +v.hour, +v.minute, +v.second) - Math.floor(ms / 1000) * 1000;
}

// Wall-clock time in `tz` → UTC ms (second pass handles DST edges).
export function zonedToUtc(y, mo, d, hh, mm, tz) {
  const guess = Date.UTC(y, mo, d, hh, mm);
  const first = guess - tzOffset(guess, tz);
  return guess - tzOffset(first, tz);
}

// Calendar date + minutes-of-day of instant `ms` in `tz`.
export function zonedParts(ms, tz) {
  const off = tzOffset(ms, tz);
  const local = new Date(ms + off);
  return {
    y: local.getUTCFullYear(), mo: local.getUTCMonth(), d: local.getUTCDate(),
    minutes: local.getUTCHours() * 60 + local.getUTCMinutes(),
  };
}

export const uiLocale = (lang) => (!lang || lang === 'en' ? 'en-GB' : lang);

export const fmtInTz = (ms, tz, opts, lang) =>
  new Intl.DateTimeFormat(uiLocale(lang), { timeZone: tz, ...opts }).format(new Date(ms));
